import axios from "axios";
import {
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_DETAILS_FAIL,
} from "../constants/productConstants";

/* 📦 TERMÉKEK LISTÁZÁSA */
export const listProducts = () => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_LIST_REQUEST });

    const { language } = getState().language;
    const { data } = await axios.get("/api/products/", {
      params: language && language !== "hu" ? { lang: language } : {},
    });

    dispatch({
      type: PRODUCT_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_LIST_FAIL,
      payload:
        error.response?.data?.detail ||
        "Nem sikerült betölteni a termékek listáját.",
    });
  }
};

/* 🔍 TERMÉK RÉSZLETEI */
export const listProductDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_DETAILS_REQUEST });

    const { language } = getState().language;
    const { data } = await axios.get(`/api/products/${id}`, {
      params: language && language !== "hu" ? { lang: language } : {},
    });

    dispatch({
      type: PRODUCT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAILS_FAIL,
      payload:
        error.response?.data?.detail ||
        "Nem sikerült betölteni a termék adatait.",
    });
  }
};
